import { USER_PROFILE_GETTER } from "./apis";

export const homePageAction = async () => {
  try {
    const res = await fetch(USER_PROFILE_GETTER, {
      method: "GET",
      credentials: "include",
    });

    if (res.status === 401 || res.status === 403) {
      return null;
    }

    if (!res.ok) {
      console.error("Profile API failed:", res.status);
      return null;
    }

    return await res.json();
  } catch (error) {
    console.error("Profile request error:", error);
    return null;
  }
};
